<div class="icon-container">
    <mat-icon svgIcon="traigo-pin" class="traigo-pin"></mat-icon>
    <div class="icon-shadow"></div>
</div>
